module.exports = __webpack_public_path__ + "static/media/icon-log.65a2ee46.svg";